export function initBackgroundScroll() {
  const background = document.querySelector(".background");
  const backgroundImg = document.querySelector(".background img");

  if (!background || !backgroundImg) return;

  const originalY = parseInt(getComputedStyle(document.body).getPropertyValue("--object-position-y")) || 10;

  function updateBackground() {
    const denominator = document.documentElement.scrollHeight - window.innerHeight || 1; // Prevent division by zero
    const scrollProgress = Math.min(window.scrollY / denominator, 1);

    const behavior = getComputedStyle(document.body).getPropertyValue("--behavior").trim();

    if (behavior === "not-collapsed") {
      const maxY = Math.min(originalY + 20, 100);
      const newY = originalY + scrollProgress * (maxY - originalY);

      if (!isNaN(newY)) {
        background.style.setProperty("--object-position-y", `${newY}%`);
      } else {
        console.warn("Invalid scroll calculation:", {
          originalY,
          scrollProgress,
          maxY,
          newY
        });
      }
      background.style.removeProperty("--scroll-opacity");
    } else {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const scrollThreshold = viewportHeight * 0.7; // 70% of viewport height
      const mobileProgress = Math.min(scrollY / scrollThreshold, 1);
      const opacity = 1 - mobileProgress;
      background.style.setProperty("--scroll-opacity", opacity);
      background.style.removeProperty("--bg-img-pos-y");
    }
  }

  ["scroll", "touchmove", "resize"].forEach(eventType => {
    window.addEventListener(eventType, updateBackground, { passive: true });
  });

  updateBackground();
}
